import React from 'react';
import '../../../Static/Master/SalepartyReg.css';
const Pagination = ({ currentPage, npages, handlePrevPage, handleNextpage, setCurrentPage, renderPaginationButtons, totalCount }) => {
    return (
        <div className='pagination-container'>
            <div className='pagination-box'>
                <label>Pagination:</label>
                <ul className='pagination'>
                    <button className='page-link' onClick={() => setCurrentPage(0)}>First</button>
                    <button className='page-link' disabled={currentPage === 0} onClick={handlePrevPage}>Prev</button>
                    {renderPaginationButtons()}
                    <button className='page-link' disabled={currentPage === npages} onClick={handleNextpage}>Next</button>
                    <button className='page-link' onClick={() => setCurrentPage(npages)}>Last</button>
                    <span>Total Entries: {totalCount}</span>
                </ul>
            </div>
        </div>
    );
};

export default React.memo(Pagination);
